/* Ersatzteil-Anfrageseite — industrie24.com
   Sprung zum Formular, paralleler Versand an HubSpot. */
(function() {
  var HUBSPOT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/26206618/c5e84055-1511-44ae-973c-3827694830e7';

  var form = document.getElementById('ersatzteil-anfrage');
  var box = document.getElementById('anfrage');

  // "Jetzt Angebot anfordern" → zum Formular scrollen, hervorheben, Namensfeld fokussieren
  document.querySelectorAll('[data-etp-focus]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      if (!box) return;
      e.preventDefault();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.classList.remove('is-highlighted'); void box.offsetWidth; box.classList.add('is-highlighted');
      var first = form && form.querySelector('input[name="contact[Name]"]');
      if (first) setTimeout(function() { first.focus({ preventScroll: true }); }, 450);
    });
  });

  // Rechte Spalte: beim Scrollen stehen lassen. Ist sie höher als das Fenster, so verschieben,
  // dass ihr unteres Ende (das Formular) sichtbar bleibt.
  var aside = document.querySelector('.etp__aside');
  function stickyTop() {
    if (!aside || window.innerWidth < 1000) { if (aside) aside.style.top = ''; return; }
    aside.style.top = Math.min(100, window.innerHeight - aside.offsetHeight - 24) + 'px';
  }
  if (aside) {
    stickyTop();
    window.addEventListener('resize', stickyTop);
    if (window.ResizeObserver) new ResizeObserver(stickyTop).observe(aside);
  }

  // "Preise & Zustände ansehen" → zum Preiskasten (externes Lager) und hervorheben
  document.querySelectorAll('[data-etp-focus-ext]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var ext = document.querySelector('.etp-ext');
      if (!ext) return;
      e.preventDefault();
      ext.scrollIntoView({ behavior: 'smooth', block: 'center' });
      ext.classList.remove('is-highlighted'); void ext.offsetWidth; ext.classList.add('is-highlighted');
      setTimeout(function () { ext.classList.remove('is-highlighted'); }, 2500);
    });
  });

  // Seiten mit Preisen: Formular ist verborgen, bis eine Option gewählt wird – oder dieser Link geklickt wird
  document.querySelectorAll('[data-etp-show-form]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!box) return;
      e.preventDefault();
      box.hidden = false;
      var other = document.querySelector('[data-etp-other]');
      if (other) other.hidden = true;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.classList.remove('is-highlighted'); void box.offsetWidth; box.classList.add('is-highlighted');
      var first = form && form.querySelector('input[name="contact[Name]"]');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
    });
  });

  // Sobald eine Option gewählt ist, braucht es die Ausweichzeile nicht mehr
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-etp-bestellen]')) return;
    var other = document.querySelector('[data-etp-other]');
    if (other) other.hidden = true;
  });

  if (!form) return;

  form.addEventListener('submit', function() {
    try {
      var fd = new FormData(form);
      var name = (fd.get('contact[Name]') || '').trim();
      var parts = name.split(/\s+/);
      var message = (fd.get('contact[body]') || '').trim();
      var angebot = (fd.get('contact[Angebot]') || '').trim();  // ausgewähltes Angebot aus dem externen Lager → eigenes HubSpot-Feld
      var payload = {
        fields: [
          { name: 'firstname', value: parts[0] || '' },
          { name: 'lastname', value: parts.slice(1).join(' ') || '' },
          { name: 'email', value: fd.get('contact[email]') || '' },
          { name: 'phone', value: fd.get('contact[Telefon]') || '' },
          { name: 'company', value: fd.get('contact[Firma]') || '' },
          { name: 'anfragehan', value: fd.get('contact[HAN_MPN]') || '' },
          { name: 'anfragehersteller', value: fd.get('contact[Hersteller]') || '' },
          { name: 'anfragesku', value: '' },
          { name: 'anfrageproduktlink', value: fd.get('contact[Produktlink]') || '' },
          { name: 'anfragemenge', value: fd.get('contact[Menge]') || '' },
          { name: 'anfragegebrauchtteilok', value: fd.get('contact[Gebrauchtteil_Alternative]') ? 'true' : 'false' },
          { name: 'anfragenachricht', value: message },
          { name: 'anfrageangebot', value: angebot },
          { name: 'address', value: (fd.get('contact[Strasse]') || '').trim() },
          { name: 'zip', value: (fd.get('contact[PLZ]') || '').trim() },
          { name: 'city', value: (fd.get('contact[Ort]') || '').trim() },
          { name: 'country', value: (fd.get('contact[Land]') || '').trim() },
            { name: 'anfrageustid', value: (fd.get('contact[UStIdNr]') || '').trim() },
            { name: 'anfragelieferadresse', value: (fd.get('contact[Lieferadresse]') || '').trim() }
        ],
        context: { pageUri: location.href, pageName: document.title }
      };
      fetch(HUBSPOT_URL, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function() {});
    } catch (e) {}
  });
})();
